module.exports = __webpack_public_path__ + "a311c93919d4751dd8e633a710206825.png";